export default __webpack_public_path__ + "static/media/ragno2.a63f9ddd.png";